import { ComponentClass, Component, ErrorInfo } from 'react';

import { ErrorPanel } from '@backstage/core-components';

/** @public */
export type ErrorBoundaryProps = {
  onError?: (error: Error, errorInfo: string) => null;
};

type State = {
  error?: Error;
  errorInfo?: ErrorInfo;
};

/**
 * Error boundary for plugins.
 * @public
 */
export const PluginErrorBoundary: ComponentClass<ErrorBoundaryProps, State> =
  class PluginErrorBoundary extends Component<ErrorBoundaryProps, State> {
    constructor(props: ErrorBoundaryProps) {
      super(props);
      this.state = {
        error: undefined,
        errorInfo: undefined,
      };
    }

    /**
     * Handle errors.
     * @param error The error
     * @param errorInfo Information about the error
     */
    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
      this.setState({ error, errorInfo });
    }

    /**
     * Render the error boundary.
     */
    render() {
      const { children } = this.props;
      const { error } = this.state;

      if (!error) {
        return children;
      }

      return (
        <ErrorPanel
          title="This information is maintained by a DevHub Extensibility Partner. For error assistance, click PLUGIN SUPPORT for support details."
          error={error}
        />
      );
    }
  };
